import React, { useEffect, useState } from "react";

export default function BlogBannerContainer(props) {
  const full = props.full;
  return (
    <>
      <div className="blog__banner center_container">
        <div className="container">
          <div className="row row--grid">
            <div className="w-full">
              <ul className="breadcrumb">
                <li className="breadcrumb__item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb__item breadcrumb__item--active">
                  Blog
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
